<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <h1 class="title-default">Home</h1>
    <p class="welcome-message">
      Olá, <span class="display-name">{{ nomeUsuario }}</span>! Que bom ter você de volta na ATS.
    </p>

    <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>

    @if (listaModulos && listaModulos.length > 0) {
    <div class="container-geral">
      <p class="modules-description">
        Tudo pronto para começar! Navegue pelos seus módulos abaixo e acesse as ferramentas para impulsionar sua
        gestão.
      </p>
      <div class="container-atalhos">
        @for (modulo of listaModulos; track modulo.idModulo) {
        <a mat-ripple class="atalho-card" routerLink="{{modulo.uri}}">
          <div class="icon-container">
            <span class="material-symbols-outlined">{{modulo.googleIconClass}}</span>
          </div>
          <label>{{modulo.nome}}</label>
        </a>
        }
      </div>
    </div>
    }
  </div>
</div>